module.exports = __webpack_public_path__ + "static/media/sono.95949043.svg";